// Lodop打印插件集成
class LodopManager {
  constructor() {
    this.LODOP = null
    this.isLoaded = false
    this.init()
  }

  // 初始化Lodop插件
  init() {
    // 检查是否已经加载了Lodop插件
    if (window.LODOP) {
      this.LODOP = window.LODOP
      this.isLoaded = true
      return
    }

    // 动态加载Lodop插件
    this.loadLodopScript()
  }

  // 加载Lodop脚本
  loadLodopScript() {
    return new Promise((resolve, reject) => {
      // 检查是否已经存在Lodop脚本
      if (document.querySelector('script[src*="Lodop"]')) {
        this.checkLodopStatus()
        resolve()
        return
      }

      // 创建script标签加载Lodop插件
      const script = document.createElement('script')
      script.src = 'http://localhost:8000/CLodopfuncs.js' // 本地Lodop服务地址
      script.onload = () => {
        this.checkLodopStatus()
        resolve()
      }
      script.onerror = () => {
        console.warn('Lodop插件加载失败，请确保Lodop服务正在运行')
        reject(new Error('Lodop插件加载失败'))
      }
      document.head.appendChild(script)
    })
  }

  // 检查Lodop状态
  checkLodopStatus() {
    if (window.LODOP) {
      this.LODOP = window.LODOP
      this.isLoaded = true
      console.log('Lodop插件加载成功')
    } else {
      console.warn('Lodop插件未正确加载')
    }
  }

  // 获取Lodop实例
  getLodop() {
    if (!this.isLoaded) {
      console.error('Lodop插件未加载')
      return null
    }
    return this.LODOP
  }

  // 创建打印任务
  createPrintTask() {
    const LODOP = this.getLodop()
    if (!LODOP) return null

    LODOP.PRINT_INIT('打印任务')
    return LODOP
  }

  // 设置纸张大小
  setPaperSize(LODOP, width, height) {
    if (!LODOP) return
    LODOP.SET_PRINT_PAGESIZE(1, width, height, '')
  }

  // 添加文本
  addText(LODOP, text, x, y, width, height, fontSize = 12, fontName = '微软雅黑', color = '#000000', textAlign = 'left') {
    if (!LODOP) return
    LODOP.ADD_PRINT_TEXT(x, y, width, height, text)
    LODOP.SET_PRINT_STYLEA(0, 'FontName', fontName)
    LODOP.SET_PRINT_STYLEA(0, 'FontSize', fontSize)
    LODOP.SET_PRINT_STYLEA(0, 'FontColor', color)
    LODOP.SET_PRINT_STYLEA(0, 'Alignment', textAlign === 'center' ? 2 : (textAlign === 'right' ? 3 : 1))
    // 不设置边框
    LODOP.SET_PRINT_STYLEA(0, 'BorderStyle', 0)
  }

  // 添加表格
  addTable(LODOP, data, x, y, width, height) {
    if (!LODOP) return
    LODOP.ADD_PRINT_TABLE(x, y, width, height, data)
  }

  // 添加二维码
  addQRCode(LODOP, content, x, y, width, height) {
    if (!LODOP) return
    // 使用Lodop的二维码功能
    LODOP.ADD_PRINT_BARCODE(x, y, width, height, 'QRCode', content)
    // 设置二维码样式
    LODOP.SET_PRINT_STYLEA(0, 'ShowBarText', 0) // 不显示条码文字
  }

  // 预览打印
  previewPrint() {
    const LODOP = this.createPrintTask()
    if (!LODOP) {
      alert('Lodop插件未加载，无法预览打印')
      return
    }
    LODOP.PREVIEW()
  }

  // 直接打印
  print() {
    const LODOP = this.createPrintTask()
    if (!LODOP) {
      alert('Lodop插件未加载，无法打印')
      return
    }

    this.generatePrintContent(LODOP)
    LODOP.PRINT()
  }

  // 生成打印内容（根据配置）
  generatePrintContent(LODOP, templateConfig, templateElements) {
    const isLandscape = templateConfig.orientation === 'landscape'
    
    // 根据方向设置纸张尺寸
    let paperWidth, paperHeight
    if (isLandscape) {
      // 横向：交换宽高
      paperWidth = templateConfig.height
      paperHeight = templateConfig.width
    } else {
      // 纵向：保持原样
      paperWidth = templateConfig.width
      paperHeight = templateConfig.height
    }
    
    // 设置纸张大小和方向
    this.setPaperSize(LODOP, paperWidth, paperHeight)
    
    // 设置打印方向
    if (isLandscape) {
      LODOP.SET_PRINT_PAGESIZE(2, paperWidth, paperHeight, '') // 2表示横向
    } else {
      LODOP.SET_PRINT_PAGESIZE(1, paperWidth, paperHeight, '') // 1表示纵向
    }
    
    // 只添加画布中的模板元素，不添加额外内容
    templateElements.forEach(element => {
      if (element.type === 'table') {
        // 处理表格元素
        const tableHtml = this.buildTableHtml(element)
        const tableWidthPx = element.columns.reduce((acc, c) => acc + (c.width || 0), 0)
        LODOP.ADD_PRINT_HTM(
          parseInt(element.style.top) || 0,
          parseInt(element.style.left) || 0,
          tableWidthPx,
          element.rowHeight * (element.data.length + 1),
          tableHtml
        )
      } else if (element.type === 'text') {
        // 处理文本元素
        this.addText(
          LODOP, 
          element.content, 
          parseInt(element.style.left) || 0, 
          parseInt(element.style.top) || 0, 
          element.style.width ? parseInt(element.style.width) : 100, 
          element.style.height ? parseInt(element.style.height) : 20, 
          parseInt(element.style.fontSize) || 12, 
          element.style.fontFamily || '微软雅黑',
          element.style.color || '#000000',
          element.style.textAlign || 'left'
        )
      } else if (element.type === 'qrcode') {
        // 处理二维码元素
        this.addQRCode(
          LODOP,
          element.content,
          parseInt(element.style.left) || 0,
          parseInt(element.style.top) || 0,
          parseInt(element.style.width) || 80,
          parseInt(element.style.height) || 80
        )
      }
    })
  }

  buildTableHtml(tableEl) {
    // 根据表格样式决定是否显示边框
    const showBorder = tableEl.style?.border && tableEl.style.border !== 'none'
    const borderStyle = showBorder ? 'border: 1px solid #999;' : 'border: none;'
    
    let html = `<table cellspacing="0" cellpadding="4" style="border-collapse:collapse;font-family:${tableEl.style?.fontFamily || '微软雅黑'};font-size:${tableEl.style?.fontSize || '12'}px;${borderStyle}">`
    
    // 表头
    html += '<thead><tr>' + tableEl.columns.map(c => 
      `<th style="width:${c.width}px;text-align:center;font-weight:bold;${showBorder ? 'border: 1px solid #999;' : 'border: none;'}padding:4px;">${c.title}</th>`
    ).join('') + '</tr></thead>'
    
    // 表体
    html += '<tbody>' + tableEl.data.map(row => 
      '<tr>' + tableEl.columns.map(c => 
        `<td style="width:${c.width}px;${showBorder ? 'border: 1px solid #999;' : 'border: none;'}padding:4px;">${row[c.id] ?? ''}</td>`
      ).join('') + '</tr>'
    ).join('') + '</tbody>'
    
    html += '</table>'
    return html
  }

  // 检查Lodop服务状态
  checkServiceStatus() {
    return new Promise((resolve) => {
      if (!this.isLoaded) {
        resolve(false)
        return
      }

      try {
        const LODOP = this.getLodop()
        if (LODOP && LODOP.VERSION) {
          resolve(true)
        } else {
          resolve(false)
        }
      } catch (error) {
        console.error('检查Lodop服务状态失败:', error)
        resolve(false)
      }
    })
  }
}

// 创建全局实例
const lodopManager = new LodopManager()

export default lodopManager
